/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type { EntityType } from 'embercom/models/data/entity-types';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';
import type { ViewId } from 'embercom/services/reporting-views';

export default class ContentController extends Controller {
  queryParams = ['section', 'openSectionId', 'openSalesforceSync', 'salesforceSyncStep'];
  @tracked showSetupModal = false;
  @tracked openSectionId?: string;
  @tracked setupModalEntryPoint?: ViewId = undefined;
  @tracked selectedEntityType: EntityType | null = null;
  @tracked openSalesforceSync?: boolean;
  @tracked salesforceSyncStep?: number;
  @service declare knowledgeHubService: KnowledgeHubService;
  @service declare appService: AppService;
  @service navbarCollapsingService: $TSFixMe;

  @action async closeSetupModal() {
    this.showSetupModal = false;
    this.selectedEntityType = null;
    this.setupModalEntryPoint = undefined;
    await this.knowledgeHubService.removeEmptySources();
    this.knowledgeHubService.onSummaryChange();
  }

  @tracked showPreview = true;

  @action setOpenSectionId(id: string | undefined) {
    this.openSectionId = id;
  }

  @action
  toggleSidebar() {
    this.navbarCollapsingService.toggleNavbarCollapsed();
    let focusIsOnToggleButton = Boolean(
      document.activeElement?.closest('[data-submenu-collapse-toggle-button]'),
    );
    // we don't want the sidebar button to stay focused after click
    if (focusIsOnToggleButton) {
      (document.activeElement as HTMLElement)?.blur();
    }
  }

  @action
  togglePreview() {
    this.showPreview = !this.showPreview;
  }

  @action
  toggleSalesforceSync() {
    if (this.openSalesforceSync) {
      this.openSalesforceSync = undefined;
      this.salesforceSyncStep = undefined;
    } else {
      this.openSalesforceSync = true;
    }
  }

  @action
  setSalesforceSyncStep(step: number) {
    this.salesforceSyncStep = step;
  }
}
